<template>
  <div>
    <NuxtPage />
  </div>
</template>

<script setup>
import { useCartStore } from "~/stores";
import { usePostHog } from "#imports";
import { useRoute } from "vue-router";

const cartStore = useCartStore();
const { posthog } = usePostHog();
const route = useRoute();

cartStore.$subscribe(() => {
  localStorage.setItem(LOCALSTORAGE_KEYS.cart, JSON.stringify(cartStore.cart));
});

const trackPageView = (page) => {
  posthog.capture("$pageview", {
    page,
    title: document.title,
  });
};

const trackPageLeave = (page) => {
  posthog.capture('$pageleave', {
    page,
    title: document.title
  })
}

onMounted(() => {trackPageView(route.fullPath)});
onMounted(() => {
  let savedCart = localStorage.getItem(LOCALSTORAGE_KEYS.cart) || "{}";
  cartStore.setCart(JSON.parse(savedCart));
});

watch(() => route.fullPath, (newPath)=>{
  trackPageView(newPath)
  trackPageLeave(route.fullPath);
})
</script>
